import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_FAILURE,
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_LOADING,
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_REQUEST,
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_RESET,
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_SUCCESS,
  GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
  GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0,
  GET_MDS_ASSESSMENT_RANGE_REQUEST,
} = therapyPlanningAction;

function* updateUncoveredDayInTherapyFunction(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_LOADING });
    const response = yield call(
      therapyPlanningService.updateTherapyPlanningUncoveredDay,
      payload?.payload
    );
    if (response?.status === 200) {
      yield put({
        type: UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_SUCCESS,
        payload: {
          response: response.data,
          requestedPayload: {
            patientId: payload?.payload?.patientId,
            // abortToken: therapyPlanningAbort.token,
            therapyType: payload?.payload?.params?.discipline,
            groupType: payload?.payload?.params?.type,
            source: 'GET_SINGLE_CELL',
            params: {
              providerId: payload?.payload?.providerId,
              startDate: payload?.payload?.params?.localDate,
              endDate: payload?.payload?.params?.localDate,
            },
          },
        },
      });
      //call get api's for single cell
      yield put({
        type: GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
        payload: {
          patientId: payload?.payload?.patientId,
          therapyType: payload?.payload?.params?.discipline,
          groupType: payload?.payload?.params?.type,
          source: 'GET_WEEKLY',
          params: {
            providerId: payload?.payload?.providerId,
            startDate: payload?.payload?.startDate,
            endDate: payload?.payload?.endDate,
          },
        },
      });
      yield put({
        type: GET_MDS_ASSESSMENT_RANGE_REQUEST,
        payload: {
          patientId: payload?.payload?.patientId,
          params: {
            startDate: payload?.payload?.startDate,
            endDate: payload?.payload?.endDate,
          },
        },
      });
      // yield put({
      //   type: GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0,
      //   payload: {
      //     patientId: payload?.payload?.patientId,
      //     // abortToken: therapyPlanningAbort.token,
      //     therapyType: payload?.payload?.params?.discipline,
      //     groupType: payload?.payload?.params?.type,
      //     source: 'GET_SINGLE_CELL',
      //     params: {
      //       providerId: payload?.payload?.providerId,
      //       startDate: payload?.payload?.weekStartDate,
      //       endDate: payload?.payload?.weekEndDate,
      //       discipline: payload?.payload?.params?.discipline,
      //     },
      //   },
      // });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_FAILURE, payload: error });
  }
}

function* updateUncoveredDayTherapyPlanningSaga() {
  yield takeEvery(
    UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_REQUEST,
    updateUncoveredDayInTherapyFunction
  );
}

export default updateUncoveredDayTherapyPlanningSaga;
